<template>
  <section ref="sectionRef" class="invitation-collage-container">
    
    <!-- 1. FLOR / SOBRE SUPERIOR -->
    <div ref="topFlowers" class="layer top-flowers-wrapper">
      <img src="@/assets/fll.png" alt="Decoración floral" class="img-fluid" />
    </div>

    <!-- 2. VINILO DE MÚSICA (LADO IZQUIERDO) -->
    <div ref="musicDisc" class="layer music-disc-wrapper">
      <img src="@/assets/corona22.png" alt="Reproducir música" class="img-fluid" />
    </div>

    <!-- 3. FOTO DE LA QUINCEAÑERA (LADO DERECHO SUPERPUESTO) -->
    <div ref="photoCard" class="layer photo-card-wrapper">
      <img src="@/assets/princ.png" alt="Foto Quinceañera" class="img-fluid photo-img" />
    </div>

    <!-- 4. TARJETA PRINCIPAL (CÓDIGO DE VESTIMENTA EN PRIMER PLANO) -->
    <div ref="mainCard" class="layer main-card-wrapper">
      <div class="dc-card">
        
        <!-- Título en dos líneas -->
        <h2 ref="title" class="dc-title"><br />
          <span>Código</span><br />
          <span class="script">de Vestimenta</span>
        </h2>

        <!-- Etiqueta -->
        <div ref="badge" class="dc-badge">FORMAL</div>

        <!-- Ilustración vestido / traje -->
        <img
          ref="figure"
          src="@/assets/codigo.png"
          alt="Código de vestimenta"
          class="dc-figure"
        />

        <!-- Nota sobre el color reservado -->
        <p ref="note" class="dc-note">
          Reservamos el Color <br>Dusty Blue <br> exclusivamente para la quinceañera.
        </p>

      </div>
    </div>

  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeCollage',
  setup() {
    const sectionRef = ref(null)
    const topFlowers = ref(null)
    const musicDisc = ref(null)
    const photoCard = ref(null)
    const mainCard = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)

    let ctx

    onMounted(async () => {
      await nextTick()
      if (!sectionRef.value) return

      // GSAP Context asegura una limpieza limpia del componente en Vue 3
      ctx = gsap.context(() => {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: sectionRef.value,
            start: 'top 85%', // Comienza justo cuando el elemento entra al visor
            end: 'bottom 40%',
            scrub: 0.6,        // Vincula la animación al scroll de forma fluida y orgánica
            invalidateOnRefresh: true
          }
        })

        /* ANIMACIONES SECUENCIALES DEL COLLAGE LIGADAS AL SCROLL */
        tl.from(topFlowers.value, {
          opacity: 0,
          y: -40,
          duration: 1,
          ease: 'power3.out'
        })
        .from(musicDisc.value, {
          opacity: 0,
          x: -50,
          rotation: -20,
          duration: 1,
          ease: 'back.out(1.2)'
        }, '-=0.5')
        .from(photoCard.value, {
          opacity: 0,
          x: 50,
          rotation: 12,
          duration: 1,
          ease: 'power3.out'
        }, '-=0.7')
        .from(mainCard.value, {
          opacity: 0,
          y: 50,
          scale: 0.9,
          duration: 1.2,
          ease: 'back.out(1.4)'
        }, '-=0.8')

        /* ANIMACIÓN DEL CONTENIDO INTERNO */
        .from(title.value, {
          opacity: 0,
          y: -20,
          filter: 'blur(4px)',
          duration: 0.8,
          ease: 'power2.out'
        }, '-=0.6')
        .from([badge.value, figure.value], {
          opacity: 0,
          scale: 0.8,
          duration: 0.8,
          stagger: 0.15,
          ease: 'back.out(1.5)'
        }, '-=0.4')
        .from(note.value, {
          opacity: 0,
          y: 20,
          duration: 0.8,
          ease: 'power2.out'
        }, '-=0.4')
      }, sectionRef.value)

      setTimeout(() => {
        ScrollTrigger.refresh()
      }, 200)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return {
      sectionRef,
      topFlowers,
      musicDisc,
      photoCard,
      mainCard,
      title,
      badge,
      figure,
      note
    }
  }
}
</script>

<style scoped>
/* CONTENEDOR PRINCIPAL - AMPLIADO PARA EVITAR QUE SE CORTE LA TARJETA */
.invitation-collage-container {
  position: relative;
  width: 100%;
  max-width: 580px;
  min-height: 1120px; /* 🔥 Aumentado para dar espacio suficiente a la tarjeta inferior */
  margin: 0 auto;
  margin-bottom: 60px;
  overflow: visible; /* 🔥 Evita que se corte la última tarjeta */
  box-sizing: border-box;
}

.img-fluid {
  width: 100%;
  height: auto;
  display: block;
}

.layer {
  position: absolute;
}

/* 1. FLOR Y SOBRE EN LA PARTE SUPERIOR */
.top-flowers-wrapper {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 85%;
  z-index: 1;
}

/* 2. VINILO DE MÚSICA (LADO IZQUIERDO) */
.music-disc-wrapper {
  top: 435px;
  left: 28%;
  width: 180px;
  z-index: 12;
}

/* 3. FOTO DE LA FESTEJADA (DERECHA SUPERPUESTA CON ROTACIÓN) */
.photo-card-wrapper {
  top: 210px;
  right: 4%;
  width: 250px;
  z-index: 3;
  transform: rotate(6deg);
  border-radius: 14px;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18);
}

.photo-img {
  border-radius: 14px;
}

/* 4. TARJETA PRINCIPAL (UBICACIÓN Y DIMENSIONES) */
.main-card-wrapper {
  bottom: 0px; /* 🔥 Ajustado dentro del nuevo alto del contenedor */
  left: 6%;
  width: 88%;
  z-index: 4;
  background: url('@/assets/75d52627f5cef26838f626d8b6b3a6ee.png') no-repeat center center;
  background-size: 100% 100%;
  padding: 60px 24px 60px;
  box-shadow: 0 14px 32px rgba(0, 0, 0, 0.25);
  border-radius: 18px;
}

.dc-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #ffffff;
}

/* TÍTULOS Y FUENTES AMPLIADAS CON MAYOR TAMAÑO */
.dc-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(38px, 9vw, 46px) !important; /* 🔥 Letra base del título más grande */
  line-height: 1.15;
  margin: 0 0 10px;
  color: #ffffff;
}

.dc-title .script {
  font-family: 'CynthiaJuneJF', 'Great Vibes', cursive;
  font-size: clamp(54px, 13vw, 68px) !important; /* 🔥 "de Vestimenta" mucho más grande */
  font-weight: normal;
}

/* BADGE FORMAL MÁS GRANDE */
.dc-badge {
  display: inline-block;
  background: linear-gradient(135deg, #d4af37 0%, #fff3a8 50%, #aa7c11 100%);
  color: #333333;
  font-family: 'Playfair Display', serif;
  font-weight: 800;
  font-size: 20px; /* 🔥 Badge ampliado */
  letter-spacing: 3px;
  padding: 8px 26px;
  border-radius: 25px;
  margin: 12px 0 16px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
}

/* ILUSTRACIÓN DE VESTIMENTA */
.dc-figure {
  width: 90%;
  max-width: 220px;
  height: auto;
  margin: 12px 0;
}

/* NOTA SOBRE EL COLOR RESERVADO CON LETRAS MÁS GRANDES */
.dc-note {
  font-family: 'Playfair Display', serif;
  font-size: 22px !important; /* 🔥 Texto explicativo significativamente más grande */
  line-height: 1.4;
  margin: 12px 0 0;
  padding: 0 8px;
  color: rgba(255, 255, 255, 0.98);
  font-weight: 500;
}
</style>